import React, { Component } from 'react'
import { connect } from 'react-redux'
import { signIn, signInWithGoogle } from '../../store/actions/authActions'
import { Redirect } from 'react-router-dom'
import { Helmet } from 'react-helmet';

class SignIn extends Component {
    state = {
        email: '',
        password: ''

    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        })
    }

    handleSubmit = (e) => {
        e.preventDefault()
        this.props.signIn(this.state)
    }

    render() {
        const { authError, auth, signInWithGoogle } = this.props
        if (auth.uid)
            return <Redirect to='/' />

        return (
            <div className="container">
                 <Helmet>
                    <title>Sign In - Bright Youth Community</title>
                </Helmet>

                <form onSubmit={this.handleSubmit} className="white">
                    <div className="row">
                        <a onClick={signInWithGoogle}> Log in with Google </a>
                    </div>

                    <h5 className="grey-text text-darken-3">Giriş Yap</h5>
                    <div className="input-field">
                        <label htmlFor="email">E-posta</label>
                        <input type="email" id="email" onChange={this.handleChange}></input>
                    </div>
                    <div className="input-field">
                        <label htmlFor="password">Şifre</label>
                        <input type="password" id="password" onChange={this.handleChange}></input>
                    </div>
                    <div className="input-field">
                        <button className="btn pink lighten-1 z-depth-0">Giriş Yap</button>
                        <div className="red-text center">
                            {authError ? <p>{authError} </p> : null}

                        </div>
                    </div>

                </form>

            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        authError: state.auth.authError,
        auth: state.firebase.auth
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        signIn: (creds) => dispatch(signIn(creds)),
        signInWithGoogle: () => dispatch(signInWithGoogle())
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(SignIn)
